var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchdrivers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "bytt sj\\xE5for",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.45983 5.21825H0.199219V21.0426C0.199219 22.2859 1.2165 23.3032 2.45983 23.3032H18.2841V21.0426H2.45983V5.21825ZM20.5448 0.697021H6.98106C5.73773 0.697021 4.72045 1.7143 4.72045 2.95764V16.5213C4.72045 17.7647 5.73773 18.7819 6.98106 18.7819H20.5448C21.7881 18.7819 22.8054 17.7647 22.8054 16.5213V2.95764C22.8054 1.7143 21.7881 0.697021 20.5448 0.697021ZM13.7629 2.95764C15.6392 2.95764 17.1538 4.47225 17.1538 6.34856C17.1538 8.22487 15.6392 9.73948 13.7629 9.73948C11.8866 9.73948 10.372 8.22487 10.372 6.34856C10.372 4.47225 11.8866 2.95764 13.7629 2.95764ZM20.5448 16.5213H6.98106V14.8259C6.98106 12.5766 11.5023 11.4349 13.7629 11.4349C16.0235 11.4349 20.5448 12.5766 20.5448 14.8259V16.5213Z",
    fill: "#016CC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchdrivers);
export default __webpack_public_path__ + "static/media/switchdrivers.2118629d.svg";
export { ForwardRef as ReactComponent };